<template>
    <div class="product mb-5 pb-4 mt-4 mt-md-0">
        <Breadcrumb :breadcrumb="breadcrumb" class="mb-5"/>
        <b-container>
            <b-row>
                <b-col md="6">
                    <ProductGallery :gallery="product.gallery" :name="product.name" :videos="product.videos.list" class="mb-5"/>
                </b-col>
                <b-col md="6">
                    <div class="d-flex align-items-baseline flex-wrap">
                        <div class="discount-porcentage product-discount-porcentage-page mb-2 mr-2" v-if="product.price_old > 0 && product.active === 'yes' && percentage(product) > 0">-{{ percentage(product) }}%</div>
                        <template v-if="product.tags && typeof product.tags === 'object' && typeof product.tags.list === 'object'">
                            <div class="tag mb-2 mr-2" v-for="tag in product.tags.list" :key="tag.id"> {{ tag.tag }}</div>
                        </template>
                    </div>
                    <div v-html="product.name" class="product-name"></div>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="product-code mr-2">
                            <span class="d-none d-md-inline-flex">Código:</span> {{ code }}
                        </div>
                        <div class="product-brand mr-2" v-if="product.brand.name">
                            <span class="mr-2">|</span>
                            <span class="d-none d-md-inline-flex"> Marca: </span>
                            <nuxt-link :to="`/busca/?filter_brands=[${product.brand.id}]`" v-html="product.brand.name"/>
                        </div>
                        <div class="product-brand mr-2" v-if="$wdconfig.modules.gift_list && $wdconfig.modules.gift_list.active">
                            <span class="mr-2">|</span>
                            <a href="#" @click.prevent="addProductList">+ Lista de presentes</a>
                        </div>
                        <Share :title="product.name" :url="$route.fullPath" class="ml-auto"/>
                    </div>
                    <hr class="mt-1 product-info-line">
                    <div v-if="product.variations.list.length">
                        <div v-for="variation in product.variations.list" :key="variation.id" class="mb-3">
                            <div v-if="variation.type === 'button'">
                                <div class="mb-1 product-variation-name">
                                    {{variation.name}} <span title="Obrigat&oacute;rio">*</span>
                                </div>
                                <div class="d-flex flex-wrap justify-content-sm-center justify-content-md-start">
                                    <button
                                        v-for="option in variation.options" :key="option.value"
                                        @click="variation.value === option.value ? variation.value = 0 : variation.value = option.value; changeVariation(true)"
                                        v-if="option.value"
                                        class="product-variation-btn mr-3 mb-3"
                                        :class="{'product-variation-selected': option.value === variation.value}"
                                        :disabled="option.disabled"
                                    >
                                        {{option.text}}
                                        <svg enable-background="new 0 0 30 30" width="14" height="14" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" v-if="option.disabled">
                                            <path d="m0 0h30v30h-30z" fill="none"/>
                                            <path d="m15.001 29c-7.72 0-14.001-6.28-14.001-14.002 0-7.718 6.281-13.998 14.001-13.998s13.999 6.28 13.999 13.998c0 7.722-6.279 14.002-13.999 14.002zm0-26.133c-6.691 0-12.134 5.442-12.134 12.131 0 6.692 5.443 12.134 12.134 12.134 6.69 0 12.131-5.441 12.131-12.134 0-6.689-5.441-12.131-12.131-12.131z" fill="#"/>
                                            <path d="m21.039 19.592-4.81-4.616 4.617-4.809-1.254-1.206-4.618 4.81-4.808-4.616-1.205 1.254 4.81 4.615-4.618 4.809 1.256 1.206 4.616-4.81 4.809 4.616z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div v-else-if="variation.type === 'image'">
                                <div class="mb-1 product-variation-name">
                                    {{variation.name}} <span title="Obrigat&oacute;rio">*</span>
                                    <div v-if="variation.value">
                                        <small>Op&ccedil;&atilde;o selecionada: <b>{{ selectedOptionVariation(variation)['text'] }}</b></small>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap product-variation-items-container">
                                    <div v-for="(option, index) in filterValidVariation(variation.options).slice(0, 8)" :key="option.value" class="product-variation-img-block d-flex justify-content-center align-items-center">
                                        <button
                                            class="aspect-ratio w-100 product-variation-btn-img"
                                            :class="[getClassAspectRatio]"
                                            :id="'variation_' + variation.id"
                                            @click="variation.value === option.value ? variation.value = 0 : variation.value = option.value; changeVariation(true)"
                                            v-if="index >= 7 ? filterValidVariation(variation.options).length <= 8 : true"
                                            :disabled="option.disabled"
                                        >
                                            <span class="aspect-content">
                                                <img :src="imageUrl(option.image)" class="product-variation-img object-fit-contain" :class="[{'product-variation-selected': option.value === variation.value }, $wdconfig.modules.product.image_object_fit]" :title="option.text" :alt="option.text">
                                            </span>
                                            <svg enable-background="new 0 0 30 30" width="14" height="14" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" v-if="option.disabled">
                                                <path d="m0 0h30v30h-30z" fill="none"/>
                                                <path d="m15.001 29c-7.72 0-14.001-6.28-14.001-14.002 0-7.718 6.281-13.998 14.001-13.998s13.999 6.28 13.999 13.998c0 7.722-6.279 14.002-13.999 14.002zm0-26.133c-6.691 0-12.134 5.442-12.134 12.131 0 6.692 5.443 12.134 12.134 12.134 6.69 0 12.131-5.441 12.131-12.134 0-6.689-5.441-12.131-12.131-12.131z" fill="#"/>
                                                <path d="m21.039 19.592-4.81-4.616 4.617-4.809-1.254-1.206-4.618 4.81-4.808-4.616-1.205 1.254 4.81 4.615-4.618 4.809 1.256 1.206 4.616-4.81 4.809 4.616z"/>
                                            </svg>
                                        </button>
                                        <template v-else>
                                            <b-button variant="link" @click="$bvModal.show('modal-variation-' + variation.id)">Ver mais</b-button>
                                            <b-modal :id="'modal-variation-' + variation.id" size="lg" hide-footer :title="variation.name" bodyClass="pt-0">
                                                <div class="row flex-wrap product-variation-items-container">
                                                    <div v-for="(option, index) in filterValidVariation(variation.options)" :key="option.value" class="product-variation-img-block in-modal d-flex justify-content-center align-items-center">
                                                        <div
                                                            class="aspect-ratio w-100"
                                                            :class="[getClassAspectRatio]"
                                                            :id="'variation_modal' + variation.id"
                                                            @click="variation.value === option.value ? variation.value = 0 : variation.value = option.value; changeVariation(true); $bvModal.hide('modal-variation-' + variation.id)"
                                                            :disabled="option.disabled"
                                                        >
                                                            <div class="aspect-content">
                                                                <img :src="imageUrl(option.image)" class="product-variation-img object-fit-contain" :class="[{'product-variation-selected': option.value === variation.value }, $wdconfig.modules.product.image_object_fit]">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <b-row>
                                    <b-col lg="6">
                                        <div class="mb-1 product-variation-name">
                                            {{variation.name}} <span title="Obrigat&oacute;rio">*</span>
                                        </div>
                                        <select
                                            :id="'variation_'+variation.id"
                                            v-model="variation.value"
                                            @change="changeVariation(true)"
                                            @focus="clickChangeVariation(variation)"
                                            class="product-select-variation"
                                        >
                                            <option :disabled="option.disabled" v-for="option in variation.options" :key="option.value" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                    <div v-if="product.active === 'yes'" class="mb-5">
                        <div v-if="product.additional" class="mb-4">
                            <b-row v-for="item in product.additional.list" :key="item.id" class="mb-3">
                                <b-col lg="6">
                                    <label :for="'additional_' + item.id" class="mb-1 product-variation-name">
                                        {{item.name}} <span title="obrigatório">*</span>
                                    </label>
                                    <select
                                        :id="'additional_' + item.id"
                                        v-model="additional[item.id]"
                                        class="product-select-variation"
                                    >
                                        <option :value="0" disabled>Selecione</option>
                                        <option :disabled="option.disabled" v-for="option in item.options" :key="option.id" :value="option.id">
                                            {{ additionalOptionLabel(option) }}
                                        </option>
                                    </select>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="d-flex flex-column flex-lg-row">
                            <div class="mb-3">
                                <div class="product-price_old" v-if="parseFloat(product.price_old)">{{ product.price_old | currency }}</div>
                                <div class="product-price_old text-decoration-none" v-show="shouldDisplayVariationPrice">&Agrave; partir de</div>
                                <div class="d-flex flex-column align-items-start">
                                    <template v-if="$wdconfig.modules.product.show_discount_price && product.payments && product.payments.length">
                                        <div class="product-price">{{ product.payments[0]['amount'] | currency }}</div>
                                        <div class="product-condition-payment">
                                            <div class="mb-2">
                                                &Agrave; vista no {{ product.payments[0]['name'] }} com <b>{{ parseFloat(product.payments[0]['discount']['value']) }}% de desconto</b>
                                            </div>
                                            <b>{{ product.price | currency }}</b>
                                            <span v-if="product.payment_condition.installments > 1">
                                                em at&eacute; <b>{{ product.payment_condition.installments }}x {{ (product.price/product.payment_condition.installments) | currency }}</b> sem juros
                                            </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="product-price">
                                            {{ (shouldDisplayVariationPrice ? lowestVariationPrice : product.price) | currency }}
                                            </div>
                                        <div>
                                            <span class="product-condition-payment" v-if="product.payment_condition.installments > 1">
                                                ou <b>{{ product.payment_condition.installments }}x de {{ (product.price/product.payment_condition.installments) | currency }}</b> sem juros
                                            </span>
                                            <span class="product-condition-payment" v-if="$wdconfig.modules.product.payment_discount && product.payments && product.payments.length">
                                                ou <b>{{ parseFloat(product.payments[0]['discount']['value']) }}%</b> de desconto no {{ product.payments[0]['name'] }}
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="product-save-money ml-0 ml-lg-5" v-if="product.active === 'yes' && product.promotions.length">
                                <div class="myblock-money">
                                    <div>
                                        <svg class="discount-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12.259 12.259">
                                            <g transform="translate(-0.002)">
                                                <path class="a" d="M11.962,6.514,6.176.736A2.506,2.506,0,0,0,5.351.214,2.5,2.5,0,0,0,4.4,0H1.038A1,1,0,0,0,.309.307,1,1,0,0,0,0,1.036V4.4a2.5,2.5,0,0,0,.214.947,2.411,2.411,0,0,0,.522.817L6.524,11.96a.991.991,0,0,0,.728.3,1.036,1.036,0,0,0,.736-.3l3.973-3.981a.991.991,0,0,0,.3-.728A1.037,1.037,0,0,0,11.962,6.514ZM3.324,3.322a1,1,0,0,1-.732.3A1.036,1.036,0,0,1,1.556,2.589,1.036,1.036,0,0,1,2.591,1.554,1.036,1.036,0,0,1,3.627,2.589,1,1,0,0,1,3.324,3.322Z" transform="translate(0)"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="title">
                                        Economize
                                    </div>
                                </div>
                                <div class="discount" v-for="promotion in product.promotions" :key="promotion.price">
                                    <div>A partir de {{promotion.quantity_initial}} {{product.unit.name}}</div>
                                    <div class="ml-3 price">{{promotion.price | currency}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3 mb-2">
                            <div class="d-flex">
                                <div class="d-flex align-items-center product-qty mr-4" v-if="$wdconfig.modules.product.change_qty_in_view">
                                    <button class="decrease" :disabled="product.qty <= product.qty_min_order" @click="changeQuantity(product, '-')">-</button>
                                    <div class="number">{{ product.qty }}</div>
                                    <button class="increase" :disabled="product.qty_max_order > 0 && product.qty >= product.qty_max_order" @click="changeQuantity(product, '+')">+</button>
                                </div>
                                <div class="product-buy d-none d-md-block flex-grow-1">
                                    <button class="btn-default pt-2 pb-2 btn-add-cart-product" ref="btn-add-cart" @click="addProduct(product)">{{ $wdconfig.modules.product.add_to_cart_button_text }}</button>
                                </div>
                            </div>
                        </div>
                        <hr class="product-shipping-info-line mt-5">
                        <b-row>
                            <b-col cols="5" xl="6">
                                <div class="product-shipping-info-subtitle">Prazo e frete</div>
                                <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" title="Não sabe?" target="_blank" rel="nofollow" class="product-shipping-info-cep">Não sei meu CEP</a>
                            </b-col>
                            <b-col class="pl-0 pl-sm-3">
                                <div class="shipping product-shipping">
                                    <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
                                        <form action="#" method="post" @submit.prevent="handleSubmit(onSubmitShipping)">
                                            <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" tag="div" v-slot="{ errors, classes, required }">
                                                <div class="input-group">
                                                    <the-mask
                                                        type="tel"
                                                        class="form-control"
                                                        id="cep"
                                                        name="cep"
                                                        v-model="cep"
                                                        :mask="['#####-###']"
                                                        :masked="true"
                                                        style="min-height: 40px;"
                                                    />
                                                    <div class="input-group-append">
                                                        <button type="submit" class="btn-default btn-reverse-color p-y px-2">
                                                            Consultar
                                                        </button>
                                                    </div>
                                                </div>
                                                <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                            </ValidationProvider>
                                        </form>
                                    </ValidationObserver>
                                    <ModalShipping :cep="cep" v-if="cep" @cep_changed="cep_changed" :product_code="product_code || product.code" :product_qty="product.qty"/>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="product.active !== 'yes'" class="mb-5">
                        <div class="product-price mb-3 unavaliable">Produto indisponível</div>
                        <div class="buy product-buy w-100 d-none d-md-block">
                            <button v-b-modal.modal-scrollable.unavaliable class="btn-unavaliable btn-default pt-2 pb-2 text-uppercase" v-if="product.code">Avise-me quando chegar</button>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <div v-if="product.description">
                <hr class="product-info-line-top d-md-none my-2">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="product-info-subtitle mt-2" id="informacoes"> Informações do produto</div>
                </div>
                <div class="product-truncate-description d-md-none d-lg-none m-0 pt-2" v-html="product.description"></div>
                <div class="d-flex justify-content-center align-items-center d-none d-sm-flex d-md-none" role="button" tabindex="0" aria-label="Ver mais informações do produto" @click="openInfo = true">
                    <div class="product-description-btn my-2 pr-1">Ver mais</div>
                    <div class="d-md-none">
                        <svg class="product-info-page-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="10" viewBox="0 0 73 51.431">
                            <g transform="matrix(0, 1, -1, 0, 73, 0)">
                                <path d="M1.737,10.125a5.931,5.931,0,0,1,8.388-8.388L31.694,23.306a5.931,5.931,0,0,1,0,8.388L10.125,53.263a5.931,5.931,0,1,1-8.388-8.388L19.112,27.5Z" transform="translate(9 6)"/>
                            </g>
                        </svg>
                    </div>
                </div>
                <hr class="product-info-line my-2">
                <div class="product-info-text d-none d-md-block mt-3" v-html="product.description"></div>
            </div>
            <div class="d-md-none product-info-text-page p-4 w-100" v-if="openInfo">
                <div class="product-info-text-page-close" @click="openInfo = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/>
                    </svg>
                </div>
                <div class="text-uppercase product-info-page-subtitle mt-4 mb-3">
                    Informações do produto
                </div>
                <div v-html="product.description" class="product-info-text"></div>
            </div>
            <div class="mt-5 pb-4" v-if="product.related.length">
                <h2 class="product-related-title"> Produtos relacionados </h2>
                <b-row class="mx-n2">
                    <b-col cols="6" :md="$wdconfig.modules.product.size_in_listing === 'large' ? 4 : 3" class="mb-3 px-2" v-for="product in product.related" :key="product.code">
                        <Product :product="product"/>
                    </b-col>
                </b-row>
            </div>
        </b-container>
        <ModalUnavaliable :product_code="product.code" :recaptcha_site="$wdconfig.default.recaptcha_site"/>
        <div class="product-buy-fixed">
            <div v-if="product.active === 'yes'" class="d-flex w-100 align-items-center justify-content-around">
                <div>
                    <div class="product-price_old" v-if="parseFloat(product.price_old)">{{product.price_old | currency}}</div>
                    <div class="product-price">
                        <template v-if="$wdconfig.modules.product.show_discount_price && product.payments && product.payments.length">
                            {{ product.payments[0]['amount'] | currency }}
                        </template>
                        <template v-else>
                            {{ product.price | currency }}
                        </template>
                    </div>
                </div>
                <button class="btn-default pt-2 pb-2 btn-add-cart-product px-0 my-1 w-50" ref="btn-mobile-add-cart" @click="addProduct(product)">{{ $wdconfig.modules.product.add_to_cart_button_text }}</button>
            </div>
            <div v-else class="d-flex w-100 align-items-center justify-content-around">
                <div class="product-price unavaliable pr-2" style="word-break: normal; white-space: normal">
                    Produto indispon&iacute;vel
                </div>
                <button v-b-modal.modal-scrollable.unavaliable class="btn-unavaliable btn-default pt-2 pb-2 px-3 my-1 text-uppercase ml-auto" v-if="product.code">Avise-me quando chegar</button>
            </div>
        </div>

        <ModalProductAdded :product="product" ref="modal-added" title="Produto adicionado na lista" />
        <ModalProductVariation :product="product" @selected="(code) => { this.product_code = code }" ref="modal-variation"/>

    </div>
</template>

<script>
    import Vue from 'vue'
    import utils from '~/mixins/utils';
    import order from '~/mixins/order';
    import product from '~/mixins/product';
    import ProductGallery from "~/components/ProductGallery";
    import Share from "~/components/Share";
    import Product from '~/components/Product';
    import ModalUnavaliable from "~/components/ModalUnavaliable";
    import Breadcrumb from "~/components/Breadcrumb";
    import ModalProductAdded from "~/components/ModalProductAdded";
    import { TheMask } from "vue-the-mask";
    import ModalProductVariation from "~/components/ModalProductVariation";
    import ModalShipping from "~/components/ModalShipping";
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import Cookies from 'js-cookie';
    import {ModalPlugin} from 'bootstrap-vue'
    Vue.use(ModalPlugin)

    export default {
        components: {
            ModalProductVariation,
            ModalProductAdded,
            Breadcrumb,
            Share,
            ProductGallery,
            Product,
            ModalUnavaliable,
            TheMask,
            ValidationProvider,
            ValidationObserver,
            ModalShipping
        },
        head() {
            return {
                title: this.product.name || '',
                meta: [
                    {
                        hid: `description`,
                        name: 'description',
                        content: this.truncate(this.product.description, 320, true)
                    },
                    {
                        hid: `twitter:card`,
                        name: 'twitter:card',
                        content: "summary_large_image"
                    },
                    {
                        hid: `og:title`,
                        property: 'og:title',
                        content: this.product.name || ''
                    },
                    {
                        hid: `og:url`,
                        property: 'og:url',
                        content: `${this.$host}${this.$route.fullPath}`
                    },
                    {
                        hid: `og:image`,
                        property: 'og:image',
                        content: this.product.gallery.length ? this.imageUrl(this.product.gallery[0].image) : this.imageUrl('')
                    },
                    {
                        hid: 'og:image:height',
                        property: 'og:image:height',
                        content: '315'
                    },
                    {
                        hid: 'og:image:width',
                        property: 'og:image:width',
                        content: '600'
                    },
                    {
                        hid: `og:description`,
                        property: 'og:description',
                        content: this.truncate(this.product.description, 320, true)
                    }
                ]
            }
        },
        mixins: [
            utils,
            order,
            product
        ],
        data() {
            return {
                title: '',
                product_code: 0,
                additional: {},
                openInfo: false,
                product_in_list: false,
                cep: ''
            }
        },
        computed: {
            breadcrumb() {
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    }
                ];
                if (this.product.category.name && this.product.category.route) {
                    breadcrumb.push({name: this.product.category.name, link: this.product.category.route});
                }
                breadcrumb.push({
                    name: this.product.name,
                    link: null
                });
                return breadcrumb;
            },
            code() {
                try {
                    if (this.$wdconfig.modules.product.code_in_listing === 'codigo_integracao') {
                        if (this.product.integration_code !== '' && this.product.integration_code !== '0') {
                            return this.product.integration_code
                        }
                    }
                    if (this.$wdconfig.modules.product.code_in_listing === 'codigo_barras') {
                        if (this.product.barcode !== '' && this.product.barcode !== '0') {
                            return this.product.barcode
                        }
                    }
                } catch (e) {
                    console.error(e)
                }
                return this.product.code
            }
        },
        methods: {
            percentage(product) {
                let result = (((product.price * 100) / product.price_old) - 100) * -1
                return Math.round(result)
            },
            additionalOptionLabel(option) {
                if (parseFloat(option.value) > 0 && option.type === 'adicionar') {
                    return `${option.name} (+${this.$options.filters.currency(option.value)})`
                }
                if (parseFloat(option.value) > 0 && option.type === 'remover') {
                    return `${option.name} (-${this.$options.filters.currency(option.value)})`
                }
                return option.name
            },
            async addProductList() {
                if (this.$store.getters.isAuth === false) {
                    this.$router.push(`/login/?next=${this.$route.fullPath}`)
                    return;
                }
                if (this.product.type === "4") {
                    if (this.product_code <= 0) {
                        if (this.$refs['modal-variation']) {
                            this.$refs['modal-variation'].showModal(() => {
                                this.addProductList()
                            })
                        } else {
                            alert('Você precisa selecionar opções do produto!')
                        }
                        return;
                    }
                }
                await this.$axios.$get('?p=Controller_ecommerce_listapresentes_api_v1&metodo=listar_listas_usuario').then((res) => {
                    if (res.status === 'success') {
                        let list_code = 0
                        if (res.lists.length) {
                            list_code = res.lists[0]['codigo']
                        }
                        const params = new URLSearchParams();
                        params.append('metodo', 'adicionar_produto');
                        params.append('codigo_produto', this.product_code || this.product.code);
                        params.append('codigo_lista', list_code);
                        this.$axios.$post('?p=Controller_ecommerce_listapresentes_api_v1', params)
                            .then((response) => {
                                this.$refs['modal-added'].show()
                            })
                            .catch(function (error) {
                                console.error(error);
                            })
                    } else {
                        console.error(res);
                    }
                }).catch(function (error) {
                    console.error(error);
                })
            },
            onSubmitShipping() {
                if (parseInt(this.product.type) === 4 && this.product_code <= 0) {
                    const base = {
                        height: this.product['height'],
                        width: this.product['width'],
                        length: this.product['length'],
                        weight: this.product['weight']
                    }
                    for (const key in this.product.variations.products) {
                        const item = this.product.variations.products[key]
                        const variation = {
                            height: item['height'],
                            width: item['width'],
                            length: item['length'],
                            weight: item['weight']
                        }
                        if (JSON.stringify(base) !== JSON.stringify(variation)) {
                            if (this.$refs['modal-variation']) {
                                this.$refs['modal-variation'].showModal(() => {
                                    this.$bvModal.show('modal-shipping-info')
                                })
                            } else {
                                alert('Você precisa selecionar opções do produto!')
                            }
                            return false
                        }
                    }
                }
                this.$bvModal.show('modal-shipping-info')
            },
            cep_changed(cep) {
                this.cep = cep
                Cookies.set("shipping_cep", this.cep)
            }
        },
        validate({params}) {
            if (!/^[a-zA-Z0-9_-]+$/.test(params.category)) {
                return false
            }
            if (!/^[a-zA-Z0-9_-]+$/.test(params.subcategory)) {
                return false
            }
            if (!/^[a-zA-Z0-9_-]+$/.test(params.subcategory2)) {
                return false
            }
            if (!/^[a-zA-Z0-9_-]+$/.test(params.produto)) {
                return false
            }
            return params.produto.split("-").pop() > 0
        },
        async asyncData({params, res, $axios, req, app, error}) {
            try {
                const product = await $axios.$get(`api/v1/ecommerce/products/?code=${params.produto.split("-").pop()}&related=yes&thumb=sim&x=700&show_payments=true`);
                if (!('qty' in product.data) && 'qty_min_order' in product.data) {
                    product.data['qty'] = product.data.multiple.quantity || 1
                    if (product.data['qty_min_order'] > 0) {
                        product.data['qty'] = product.data['qty_min_order']
                    }
                }
                if (!('qty' in product.data)) {
                    product.data['qty'] = 1
                }
                if ('unit' in product && 'precision' in product.unit) {
                    product.data.qty = product.data.qty.toFixed(product.unit.precision)
                }
                return {
                    product: product.data,
                    title: product.name
                }
            } catch (e) {
                console.error(e)
                return error({statusCode: 404, message: e.message})
            }
        },
        mounted() {
            this.FacebookViewContent(this.product.category.alias, this.product.name, this.product.type,this.product.code, this.product.price);
            if ('additional' in this.product) {
                this.product.additional.list.forEach((el, key) => {
                    this.$set(this.additional, el.id, 0)
                })
            }
            if (Cookies.get("shipping_cep") && /^\d{5}-?\d{3}$/.test(Cookies.get("shipping_cep"))) {
                this.cep = Cookies.get("shipping_cep")
            }
        }
    }
</script>
